import { render, staticRenderFns } from "./VehicleSetup.vue?vue&type=template&id=5df3a3d2&"
import script from "./VehicleSetup.vue?vue&type=script&lang=ts&"
export * from "./VehicleSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports